import { Provider } from 'react-redux';
import { InteractionStatus } from '@azure/msal-browser';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';

import App from './features/App/App';
import store from './store';

const AppWithStore = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

const AppWrapper = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  const isAuthenticationEnabled = process.env.REACT_APP_CLIENT_AUTHENTICATION === 'true';

  if (!isAuthenticationEnabled) {
    return <AppWithStore />;
  }

  // If not logged in then redirect to login page
  if (inProgress === InteractionStatus.None && !isAuthenticated) {
    instance.loginRedirect();
  }

  return (
    <AuthenticatedTemplate>
      <AppWithStore />
    </AuthenticatedTemplate>
  );
};

export default AppWrapper;
